import { createReducer, on } from '@ngrx/store';
import { Review } from '../../models/reviews.model';
import * as fromReviewsActions from '../actions/reviews.actions';

export interface ReviewsState {
    data: Review[];
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: ReviewsState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const reviewsReducer = createReducer(
    initialState,
    on(fromReviewsActions.LoadReviewsAction, (state) => ({ ...state, loading: true })),
    on(fromReviewsActions.LoadReviewsSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromReviewsActions.LoadReviewsFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromReviewsActions.SendReviewsAction, (state) => ({ ...state, loading: true })),
    on(fromReviewsActions.SendReviewsSuccessAction, (state, { review }) => ({
        ...state,
        data: state.data.map((reviewData) => review.id === reviewData.id ? review : reviewData),
        loaded: true,
        loading: false
    })),
    on(fromReviewsActions.SendReviewsFailAction, (state, { error }) => ({ ...state, error: error.message }))
);
